import { Component, OnInit, NgZone, ViewChild, AfterContentInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatSliderModule} from '@angular/material/slider';
import {take} from 'rxjs/operators';
import {FlatTreeControl} from '@angular/cdk/tree';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-newinvoice',
  templateUrl: './newinvoice.component.html',
  styleUrls: ['./newinvoice.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class NewinvoiceComponent implements OnInit {

  constructor(private _ngZone: NgZone, public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) {

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
      
      // Debounce search.
     this.productSearchTermUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value != null && value.length > 2){
          this.SearchProductsInvoicingInformation(value, this.NewProduct.ProductInvoiceInfo.Administration.ID, false);
        }
      });
   }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  DocumentDate = new FormControl(moment());
  PaymentDueDate =  new FormControl(moment());
  
  loading:boolean;
  showSearch:boolean;
  showSearchCurrent:boolean;
  SubordonatesInfo:any;
  ShowSubordronateDocumentsWarning:boolean;
  ShowShippingDetailsContainer:boolean;

  receptionURLID:any;
  IsStorno:boolean;
  NewCopy:boolean;
  CurrentInvoice: {[k: string]: any} = {};
  searchTerm:string;
  countryID:number;
  IsValidNewProduct:boolean;
  DocumentBodyLoading:boolean;
  showInvoiceVisualizer:boolean;

  resultsLength = 0;
  pageSize = 999999;
  Partners:any[];
  newPartner:any;

  partner:any;
  currentPartner:any;
  currency:any;

  newPartnerCountry:any;
  newPartnerBank:any;
  InvoicePrecision:any;
  SubordronateDocumentsMessage:string;

  showAddNewPartnerPopUp:boolean;
  showEditPartnerPopUp:boolean;

  Currencies:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Languages:any[];
  PaymentTerms:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DiscountTypes:any[];
  Agents:any[];
  DocTypes:any[];
  CashCollectTypes:any[];
  InvoiceDocType:any;
  masterData:any;
  showAccountingSeriesError:boolean;
  PurchaseInfos:any[];

  Products:any[];
  NewProduct:any;
  IsSignedByAgent:boolean;
  ShowDocumentError:boolean;

  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingMasterData:any;

  searchPartnerUpdate = new Subject<string>();
  productSearchTermUpdate = new Subject<string>();

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
        .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  ngOnInit(): void {
    this.loading = true;
    this.GetInvoiceMasterData();
    this.countryID = null;
    this.Products = new Array();
    this.initializeAddPartnerForm();
    this.showSearch = true;
    this.showSearchCurrent = true;
    
    this.GetShippingMasterData();
    this.parent.PreventBrowserClose(true);
  }

  showhideSearches(isFromPop:boolean){
    
    if(isFromPop){
      if(this.ProductsSearchResultsCOUNTPop > 0){
        this.showSearchCurrent = !this.showSearchCurrent;
      }
      else{
        this.showSearchCurrent = true;
      }
    }
    else{
      if(this.ProductsSearchResultsCOUNT > 0){
        this.showSearch = !this.showSearch;
      }
      else{
        this.showSearch = true;
      }
    }
  }

  GetInvoice(id:string, UseInvoiceLanguage:boolean, TransferAdvancedPaymentValues:boolean = false){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      NewCopy:this.NewCopy,
      UseInvoiceLanguage:UseInvoiceLanguage,
      TransferAdvancedPaymentValues:TransferAdvancedPaymentValues
    };

    this.service.GetInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        this.FillInvoiceInfo(response["Invoice"]);
        this.TestDocumentValidity();
      }

      if(this.CurrentInvoice?.ID?.length > 0 && this.CurrentInvoice?.DocType?.ID == 0 && this.CurrentInvoice.DocumentStatus.ID != -1){
        this.GetInvoicePurchasePrices();
      }
   
    });
  }

  GetInvoicePurchasePrices(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID
    };
    
    this.parent.loading = true;
  
    this.service.GetInvoicePurchasePrices(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.PurchaseInfos = response["PurchaseInfos"];

       this.CurrentInvoice.Products.forEach(product => {
        this.PurchaseInfos.forEach(info => {
          
          if(product.ProductInvoiceInfo.ID == info.ParentID){
            product.ProductInvoiceInfo.PurchaseInfo = info;
          }

        });
       });

       this.CurrentInvoice.Total.TotalPurchaseCost = response["TotalPurchaseCost"];
       this.CurrentInvoice.Total.UITotalPurchaseCost = response["UITotalPurchaseCost"];
       this.CurrentInvoice.Total.TotalPurchaseCostVAT = response["TotalPurchaseCostVAT"];
       this.CurrentInvoice.Total.UITotalPurchaseCostVAT = response["UITotalPurchaseCostVAT"];

       var i = response["Invoice"];
       this.CurrentInvoice.Total.TotalPureProfit = i.Total.TotalPureProfit;
       this.CurrentInvoice.Total.TotalPurchaseInfoUIText = i.Total.TotalPurchaseInfoUIText;

       this.CurrentInvoice.PurchaseStatus = response["InvoicePurchaseStatus"];
      }
   
      this.parent.loading = false;
    });
  }

  FillInvoiceInfo(invoice:any){

    this.partner = {};
    this.CurrentInvoice = invoice;
    this.partner = this.CurrentInvoice.Client;

    this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
    this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
    this.currency = invoice.Currency;

    if(invoice.Products.length > 0){
      this.InvoicePrecision = invoice.Products[0].ProductInvoiceInfo.DecimalPrecision;
    }

    this.Products = invoice.Products;
    this.IsStorno = invoice.IsStorno;

    if(this.NewCopy){
      this.CurrentInvoice.AccountingNumber.ID = null;
    }
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['id']){
        this.receptionURLID = params['id'];
      }
        
      if(params['IsStorno']){
        this.IsStorno = JSON.parse(params['IsStorno']);
      }

      if(params['Type']){
        this.InvoiceDocType = JSON.parse(params['Type']);
        this.CurrentInvoice.DocType = this.DocTypes.find(x => x.ID == this.InvoiceDocType);
      }

      if(params['NewCopy']){
        this.NewCopy = JSON.parse(params['NewCopy']);
      }

        if(this.IsStorno == undefined){
          this.IsStorno = false;
        }
    });

    if(this.receptionURLID != undefined && this.receptionURLID != null){
      this.GetInvoice(this.receptionURLID, false);
    }
  }

  InitializeNewInvoice(){
    
    this.CurrentInvoice.PaymentTerm = null;
    this.CurrentInvoice.Language = this.parent.User.Settings.Language;
    this.CurrentInvoice.AccountingNumber = {};
    this.CurrentInvoice.AccountingNumber.ID = null;
    this.CurrentInvoice.AccountingNumber.AccountingSeries = {};
    this.CurrentInvoice.AccountingNumber.AccountingSeries = this.AccountingSeries[0];
    this.CurrentInvoice.Client = {};
    this.CurrentInvoice.Company = {};
    this.CurrentInvoice.Company = this.parent.Company;
    this.CurrentInvoice.DocType = {};
    this.CurrentInvoice.DocumentNumber = "";
    this.CurrentInvoice.DocumentDate = null;
    this.CurrentInvoice.PaymentDueDate = null;
    this.CurrentInvoice.StockEntryDate = null;
    this.CurrentInvoice.Currency = this.currency;
    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = [];
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.Details = {};

    this.CurrentInvoice.Details.Agent = {};
    this.CurrentInvoice.Details.Agent = this.Agents[0];
    this.CurrentInvoice.Details.WayBillID = "";
    this.CurrentInvoice.Details.Delegate = "";
    this.CurrentInvoice.Details.IDCard = "";
    this.CurrentInvoice.Details.Auto = "";
    this.CurrentInvoice.Details.InternalCommentary = "";
    this.CurrentInvoice.Details.Observations = "";
    this.CurrentInvoice.Details.CashCollections = [];
    this.CurrentInvoice.Details.StockDischarging = true;
    this.CurrentInvoice.Details.SignStampSubstitute = "";
    this.CurrentInvoice.Details.IsSignedByAgent = false;

    this.CurrentInvoice.ID = null;

    this.CurrentInvoice.DocumentStatus = {};
    this.CurrentInvoice.DocumentStatus.ID = 1;

    this.CurrentInvoice.IsStorno = this.IsStorno;

    this.CurrentInvoice.Total = {};
    this.CurrentInvoice.Total.Discount = {};
    this.IsSignedByAgent = false;
  }

  initializeAddPartnerForm(){
    this.newPartner = new FormGroup({

      VAT:new FormControl(''),
      UPN:new FormControl(''),
      Name:new FormControl('', [Validators.required]),
      COCRegNumber:new FormControl(''),
  
      TaxPayer:new FormControl(''),
  
      Country:new FormControl(''),
      StateProvince:new FormControl(''),
      City:new FormControl(''),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),

      Bank:new FormControl(''),
      BankAccount:new FormControl(''),
  
      Email: new FormControl('', [Validators.email]),
      ContactName:new FormControl(''),
      Phone:new FormControl(''),
    });
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.masterData = response;
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];

        if(this.AccountingSeries == null || this.AccountingSeries.length == 0){
          if(this.receptionURLID == undefined || this.receptionURLID == null){
            this.OpenAccountingSeriesError();
          }
        }

        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];

        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.CashCollectTypes = response["CashCollectTypes"];

        this.currency = this.Currencies[0];
        this.InvoicePrecision = this.DecimalPrecisions[0];
        this.InitializeNewProduct();
        this.InitializeNewInvoice();
        this.getParamValues();
      }
   
      this.NewProductPriceContainsVAT = false;
      this.parent.loading = false;
    });
  }

  GetShippingMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetShippingMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingWays = response["ShippingWays"];
        this.ShippingServiceTypes = response["ShippingServiceTypes"];
        this.ShippingResponsabilities = response["ShippingResponsabilities"];
        this.ShippingCompanies = response["ShippingCompanies"];
        this.WeightTypes = response["WeightTypes"];
        this.ShippingMasterData = response;
      }
    });
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company,
      SearchEUVIES:true
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          if(response["NewPartnerDetected"] == true){
  
            var p = response["PendingPartner"];
            this.newPartner = new FormGroup({
  
              VAT:new FormControl(p.VAT),
              UPN:new FormControl(''),
              Name:new FormControl(p.Name, [Validators.required]),
              COCRegNumber:new FormControl(''),
          
              TaxPayer:new FormControl(p.EUVATVerified),
          
              Country:new FormControl(p.BillingAddress.Country),
              StateProvince:new FormControl(''),
              City:new FormControl(''),
              AddressLine:new FormControl(p.BillingAddress.AddressLine),
              ZipCode:new FormControl(''),
          
              Bank:new FormControl(''),
              BankAccount:new FormControl(''),
          
              Email: new FormControl('', [Validators.email]),
              ContactName:new FormControl(''),
              Phone:new FormControl(''),
            });
  
            this.showAddNewPartnerPopUp = true;
          }
          else{
            this.Partners = response["Partners"];
            this.resultsLength = response["Count"];
          }
        }
     
        this.parent.loading = false;
      });
    }
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(''),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(this.partner.BillingAddress.ZipCode),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  OpenAccountingSeriesError(){
    this.showAccountingSeriesError = true;
  }

  AddNewPartner(){

    var request = {
      Partner:{
        VAT:this.newPartner.controls['VAT'].value,
        UPN:this.newPartner.controls['UPN'].value,
        Name:this.newPartner.controls['Name'].value,
        COCRegNumber:this.newPartner.controls['COCRegNumber'].value,

        TaxPayer:false,

        BillingAddress:{
          Country:this.newPartner.controls['Country'].value,
          StateProvince:this.newPartner.controls['StateProvince'].value,
          City:this.newPartner.controls['City'].value,
          AddressLine:this.newPartner.controls['AddressLine'].value,
          ZipCode:this.newPartner.controls['ZipCode'].value,
        },
        Bank:this.newPartnerBank,
        ContactInfo:{
          Email:this.newPartner.controls['Email'].value,
          Name:this.newPartner.controls['ContactName'].value,
          Phone:this.newPartner.controls['Phone'].value,
        },
        Company:this.parent.Company
      },
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(request.Partner.Bank != null){
      request.Partner.Bank.BankAccount = this.newPartner.controls['BankAccount'].value;
    }

    if(this.newPartner.controls['TaxPayer'].touched != false && this.newPartner.controls['TaxPayer'].value != ''){
      request.Partner.TaxPayer = this.newPartner.controls['TaxPayer'].value;
    }
    else{
      request.Partner.TaxPayer = false;
    }
    
    if(this.newPartner.valid){

      this.parent.loading = true;

      this.service.AddNewPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.initializeAddPartnerForm();
          this.showAddNewPartnerPopUp = false;
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          this.GetPartnerOnAdd(response["ID"]);
        }
     
        this.parent.loading = false;
      });
       };

     if(!this.newPartner.valid){
      this.newPartner.controls['Name'].touched = true;
      this.newPartner.controls['Country'].touched = true;
      this.newPartner.controls['StateProvince'].touched = true;
      this.newPartner.controls['City'].touched = true;
      this.newPartner.controls['AddressLine'].touched = true;
      this.newPartner.controls['ZipCode'].touched = true;
      }

    }

  GetPartnerOnAdd(id:string){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:id
      };
  
      this.parent.loading = true;
  
      this.service.GetPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.partner = response["Partner"];
          this.resultsLength = 0;
          this.searchTerm='';
          this.AdjustCurrencyOnPartnerSeleciton();
          this.TestDocumentValidity();
        }
     
        this.parent.loading = false;
      });
  }

    InsertPartnerFromCloud(partner:any){

      var request = {
        Partner:partner,
        User:this.parent.User,
        Language:this.parent.getLanguage(),
      };
  
      this.parent.loading = true;
  
      this.service.AddNewPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
        
        }
        else if(response["Status"] == 1){
          this.partner.ID = response["ID"];
          this.partner.EUVATVerified = response["EUVATVerified"];
          this.parent.openSnackBar("New Partner Added", "OK", "light-info-snackbar");
        }
     
        this.parent.loading = false;
      });
    }

    initializePartnerFormFromObject(partner:any){

      this.currentPartner = new FormGroup({
  
        VAT:new FormControl(partner.VAT),
        UPN:new FormControl(partner.UPN),
        Name:new FormControl(partner.Name, [Validators.required]),
        COCRegNumber:new FormControl(partner.COCRegNumber),
    
        TaxPayer:new FormControl(partner.TaxPayer),
    
        Country:new FormControl(partner.BillingAddress.Country),
        StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
        City:new FormControl(partner.BillingAddress.City, [Validators.required]),
        AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
        ZipCode:new FormControl(partner.BillingAddress.ZipCode),
    
        Bank:new FormControl(partner.Bank),
        BankAccount:new FormControl(partner.Bank.BankAccount),
    
        Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
        ContactName:new FormControl(partner.ContactInfo.Name),
        Phone:new FormControl(partner.ContactInfo.Phone),
      });
     
      this.showEditPartnerPopUp = true;
      this.partner = partner;
    }

    UpdatePartner(){
      var request = {
        Partner:{
          ID:String,
          VAT:this.currentPartner.controls['VAT'].value,
          UPN:this.currentPartner.controls['UPN'].value,
          Name:this.currentPartner.controls['Name'].value,
          COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,
  
          TaxPayer:this.currentPartner.controls['TaxPayer'].value,
  
          BillingAddress:{
            ID:Number,
            Country:this.currentPartner.controls['Country'].value,
            StateProvince:this.currentPartner.controls['StateProvince'].value,
            City:this.currentPartner.controls['City'].value,
            AddressLine:this.currentPartner.controls['AddressLine'].value,
            ZipCode:this.currentPartner.controls['ZipCode'].value,
          },
          Bank:this.currentPartner.controls['Bank'].value,
          ContactInfo:{
            ID:Number,
            Email:this.currentPartner.controls['Email'].value,
            Name:this.currentPartner.controls['ContactName'].value,
            Phone:this.currentPartner.controls['Phone'].value,
          },
          Company:this.parent.Company,
          EUVATVerified:this.partner.EUVATVerified,
        },
        User:this.parent.User,
        Language:this.parent.getLanguage()
      };
  
      request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
      request.Partner.ID = this.partner.ID;
      request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
      request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;
  
      this.parent.loading = true;
  
      this.service.UpdatePartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
        
        }
        else if(response["Status"] == 1){
         this.showEditPartnerPopUp = false;
         this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
         this.partner = response["Partner"];
        }
     
        this.parent.loading = false;
      });
    }

    compareFn(c1: any, c2: any): boolean {
      return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }
  
    compareFirst(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  GetCurrencyLiveExchange(currency:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Currency:currency
    };

    this.parent.loading = true;

    this.service.GetCurrencyLiveExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currency = response["Currency"];
      }
   
      this.parent.loading = false;
    });
  }

  AdjustLanguageOnPartnerSeleciton(){
    this.CurrentInvoice.Language = this.partner.BillingAddress.Country.Language;
  }

  AdjustCurrencyOnPartnerSeleciton(){
    this.GetCurrencyLiveExchange(this.partner.BillingAddress.Country.Currency);
  }

  AdjustPaymentTermOnPartnerSelect(id){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:id,
      DocType:this.CurrentInvoice.DocType
    };

    this.parent.loading = true;

    this.service.AdjustPaymentTermOnPartnerSelect(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.PaymentTerm = response["Term"];

        if(this.CurrentInvoice.PaymentTerm){
          this.GetDateByPaymentTerm(this.CurrentInvoice.PaymentTerm);
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetDateByPaymentTerm(term:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Term:term,
      DocumentDate:null
    };

    if(this.DocumentDate.value != undefined && this.DocumentDate.value != null){

      if(this.DocumentDate.value._d == null || this.DocumentDate.value._d == undefined){
        this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      }

      if(this.DocumentDate.value._d != undefined){
        request.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
      }
    }

    this.parent.loading = true;

    this.service.GetDateByPaymentTerm(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DocumentDate = new FormControl(moment(response["DocumentDate"]));
        this.PaymentDueDate =  new FormControl(moment(response["DueDate"]));
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewProduct(){

    var Administration = null;

    if(this.NewProduct?.ProductInvoiceInfo?.Administration != null){
      Administration = JSON.parse(JSON.stringify(this.NewProduct?.ProductInvoiceInfo?.Administration));
    }
    else{
      Administration = JSON.parse(JSON.stringify(this.Administrations[0]));
    }

    this.NewProduct = {
      ID:null,
      GeneralType:this.ProductGeneralTypes[0],
      ProductInvoiceInfo:{
        Administration:Administration,
        Name:"",
        Code:"",
        Description:"",
        MeasuringUnit:this.MeasuringUnits[0],
        Quantity:1,
        Price:{
          VAT:this.VATRates[0]
        },
        Total:null,
        TotalVATValue:null,
      },
    };

    this.IsValidNewProduct = false;
  }

  chanveNewProductVALUE(event){
    
    this.IsValidNewProduct = false;

    if(this.NewProduct.ProductInvoiceInfo.Administration != null){
      if(this.NewProduct.ProductInvoiceInfo.MeasuringUnit != null){
        if(this.NewProduct.ProductInvoiceInfo.Price.VAT != null){
          if(this.InvoicePrecision != null){
            if(this.NewProduct.ProductInvoiceInfo.Name != null && this.NewProduct.ProductInvoiceInfo.Name.length > 0){
              if(this.NewProduct.ProductInvoiceInfo.Code != null && this.NewProduct.ProductInvoiceInfo.Code.length > 0){
                if(this.NewProduct.ProductInvoiceInfo.Price != null){
                  if((this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice != null && this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice.toString().length > 0 && this.NewProductPriceContainsVAT) || (this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice != null && this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice.toString().length > 0 && !this.NewProductPriceContainsVAT)){
                    if(this.NewProduct.ProductInvoiceInfo.Quantity > 0 && this.NewProduct.ProductInvoiceInfo.Code.length > 0 && this.NewProduct.ProductInvoiceInfo.Name.length > 0){
                      this.IsValidNewProduct = true;
                    }
                  }
                }
              }
           }
          }
        }
      }
    }
  }

  loadingSearchProducts:boolean;
  ProductsSearchResults:any[];
  ProductsSearchResultsCOUNT:number;
  ProductsSearchResultsPop:any;
  ProductsSearchResultsCOUNTPop:any;
  NewProductPriceContainsVAT:boolean;

  GetProductsFiltered(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:this.pageSize,
      IncludeStock:false
    };

    if(searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.GetProductsFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  SearchProductsInvoicingInformation(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:10,
      IncludeStock:false,
      Partner:this.partner,
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      InvoiceMasterData:this.masterData,
      NewProductPriceContainsVAT:this.NewProductPriceContainsVAT,
      DecimalPrecision:this.InvoicePrecision,
      SuggestFromPool:true,
    };

    if(searchTermProducts != null && searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.SuggestProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  GetMostRecentProductInformation(p:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GeneralDocType:this.parent.masterData.GeneralDocTypes[1].ID,
      DecimalPrecision:this.InvoicePrecision,
      Product:p,
      Partner:this.partner,
      PartnerIsClient:true,
    };
   
      this.loadingSearchProducts = true;

      this.service.GetMostRecentProductInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.IsValidNewProduct = false;
          this.chanveNewProductVALUE(null);
        }
     
        this.CheckAndGetProductSubordonates(this.NewProduct);
        this.loadingSearchProducts = false;
      });
  }

  AddProductToInvoice(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.NewProduct.ProductInvoiceInfo.Price,
      Precision:this.InvoicePrecision.ID,
      HasVAT:this.NewProductPriceContainsVAT,
      Quantity:this.NewProduct.ProductInvoiceInfo.Quantity,
      DocQuantity:this.NewProduct.ProductInvoiceInfo.DocQuantity,
      IsStorno:this.IsStorno,
      AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage
    };
  
    this.parent.loading = true;

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

          var aux = JSON.parse(JSON.stringify(this.NewProduct));

          aux.ProductInvoiceInfo.Price = response["Price"];

          aux.ProductInvoiceInfo.Price.Currency = this.currency;
          aux.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;
          aux.ProductInvoiceInfo.PriceContainsVAT = this.NewProductPriceContainsVAT;
          aux.ProductInvoiceInfo.GeneralType = this.NewProduct.GeneralType;
          aux.ProductInvoiceInfo.Quantity = response["Quantity"];
         
          aux.ProductInvoiceInfo.UIID = this.parent.newGuid();
          this.Products.push(aux);
          this.ProofAllocatesSubordonatesQuantites();
          this.TestDocumentValidity();
      }
   
      this.GetInvoiceTotalValues();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  GetInvoiceTotalValues(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:JSON.parse(JSON.stringify(this.Products)),
      Precision:this.InvoicePrecision.ID,
      IsStorno:this.IsStorno
    };

    this.parent.loading = true;

    this.service.GetInvoiceTotalValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        this.CurrentInvoice.Total.TotalQtyPriceNOVAT = response["Total"].TotalQtyPriceNOVAT;
        this.CurrentInvoice.Total.TotalVAT = response["Total"].TotalVAT;
        this.CurrentInvoice.Total.TotalQtyPriceVAT = response["Total"].TotalQtyPriceVAT;
      }
   
      this.parent.loading = false;
    });

  }

  loadingEditProduct:boolean;

  GetSingleExchange(price:any, exchangeRate:any, targetMainCurrency:boolean, precision:any): any{

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:price,
      ExchangeRate:exchangeRate,
      IsTargetMainCurrency:targetMainCurrency,
      Precision:precision
    };

    this.loadingEditProduct = true;

    this.service.GetSingleExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        return response["Price"];
      }
   
      this.loadingEditProduct = false;
    });

    return null;
  }

  DeleteAuxProduct(id:string){
    this.Products = this.Products.filter(item => item.ProductInvoiceInfo.UIID != id);
    this.ProofAllocatesSubordonatesQuantites();
    this.GetInvoiceTotalValues();
  }

  CurrentProduct:any;
  CurrentIndexProduct:number;

  SelectReceptionProductFromSearch(product:any){

    if(product.ProductInvoiceInfo != null){
      this.NewProduct = product;
      this.NewProductPriceContainsVAT = this.NewProduct.ProductInvoiceInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductInvoiceInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          Description:product.Description,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }

    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNT = 0;
    this.ProductsSearchResults = [];
  }

  SelectReceptionProductFromSearchCurrent(product:any){
    
    if(product.ProductInvoiceInfo != null){
      product.ProductInvoiceInfo.ProductID = product.ID;
      product.ProductInvoiceInfo.DecimalPrecision = this.CurrentProduct.ProductInvoiceInfo.DecimalPrecision;
      product.ProductInvoiceInfo.Description = this.CurrentProduct.ProductInvoiceInfo.Description;
      product.ProductInvoiceInfo.DescriptionRows = this.CurrentProduct.ProductInvoiceInfo.DescriptionRows;
      product.ProductInvoiceInfo.Quantity = this.CurrentProduct.ProductInvoiceInfo.Quantity;
      product.ProductInvoiceInfo.Price = this.CurrentProduct.ProductInvoiceInfo.Price;
      product.ProductInvoiceInfo.PriceContainsVAT = this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT;
      product.ProductInvoiceInfo.Total = this.CurrentProduct.ProductInvoiceInfo.Total;
      product.ProductInvoiceInfo.TotalVATValue = this.CurrentProduct.ProductInvoiceInfo.TotalVATValue;
      product.ProductInvoiceInfo.VAT = this.CurrentProduct.ProductInvoiceInfo.VAT;

      this.CurrentProduct = product;
      this.NewProductPriceContainsVAT = this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductInvoiceInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          Description:product.Description,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }
    
    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNTPop = 0;
    this.ProductsSearchResultsPop = [];
  }

  CheckAndGetProductSubordonates(p:any){
    if(p.ProductInvoiceInfo.Quantity > 0 && p.ProductInvoiceInfo.Quantity > p.DiscrepancyAmmount){
      this.GetSubordonateProducts(p);
    }
  }

  GetSubordonateProducts(p:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PageIndex:1,
      PageSize:10,
      Product:p
    };

    if(this.CurrentInvoice.DocType.ID == 0 && this.CurrentInvoice.ID == null){
      this.loadingSearchProducts = true;

      this.service.GetSubordonateProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          
        }
        else if(response["Status"] == 1){
          this.NewProduct.SubordonatesInfo = response["SubordonatesInfo"];
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  ShowReceptionEditProductContainer:boolean;
  ReserveProduct:any;

  OpenReceptionEditProduct(id:string){

    this.Products.forEach(p => {
      if(p.ProductInvoiceInfo.UIID == id){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.ReserveProduct = JSON.parse(JSON.stringify(this.CurrentProduct));
        this.ShowReceptionEditProductContainer = true;
      }
    });
  }

  RevertProduct(){
    this.CurrentProduct = this.ReserveProduct;

    for (let i = 0; i < this.Products.length ; i++) {
      if(this.Products[i].ProductInvoiceInfo.UIID == this.CurrentProduct.ProductInvoiceInfo.UIID){
        this.Products[i] = JSON.parse(JSON.stringify(this.CurrentProduct));
      }
    }
    
  }

  showProductDiscountContainer:boolean;

  ModifyReceptionProduct(maintainOpenPopUp:boolean = false){

    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Price:this.CurrentProduct.ProductInvoiceInfo.Price,
        Precision:this.InvoicePrecision.ID,
        HasVAT:this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT,
        Quantity:this.CurrentProduct.ProductInvoiceInfo.Quantity,
        DocQuantity:this.CurrentProduct.ProductInvoiceInfo.DocQuantity,
        IsStorno:this.IsStorno,
        Discount:null,
        AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage
      };
  
      if(this.CurrentProduct.ProductInvoiceInfo.Price.Discount != undefined){
        request.Discount = this.CurrentProduct.ProductInvoiceInfo.Price.Discount;
      }
  
      if(maintainOpenPopUp == false){
        this.loadingEditProduct = true;
      }
  
      this.service.GetPriceInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
           
            this.CurrentProduct.ProductInvoiceInfo.Quantity = response["Quantity"];
            this.CurrentProduct.ProductInvoiceInfo.DocQuantity = response["DocQuantity"];
  
            this.CurrentProduct.ProductInvoiceInfo.Price = response["Price"];
            
            if(maintainOpenPopUp == false){
              this.ShowReceptionEditProductContainer = false;
            }

            this.showProductDiscountContainer = false;

            if(this.CurrentProduct.ProductInvoiceInfo.ProductID != this.Products[this.CurrentIndexProduct]?.ProductInvoiceInfo?.ProductID){
              this.CurrentProduct.ProductInvoiceInfo.ID = null;
            }

            this.GenerateDescriptionRows();
            this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
        }
        
        this.ProofAllocatesSubordonatesQuantites();
        this.GetInvoiceTotalValues();
        this.loadingEditProduct = false;
      });
    }

    priceContainsVATchanged($event){

      if($event.checked == true){
  
        if(this.CurrentProduct != null){
          this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
  
        if(this.NewProduct != null){
          this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
      }
      else{
        if(this.CurrentProduct != null){
          this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice));
        }
  
        if(this.NewProduct != null){
          this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice));
        }
      }
  
      if(this.CurrentProduct != null){
        this.ModifyReceptionProduct(true);
      }
    }

    GenerateDescriptionRows(){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Description:this.CurrentProduct.ProductInvoiceInfo.Description
      };

      this.loadingEditProduct = true;
  
      this.service.GenerateDescriptionRows(request).subscribe(response => {
        if(response["Status"] == 1){
          this.CurrentProduct.ProductInvoiceInfo.DescriptionRows = response["DescriptionRows"];
          this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
        }
      });
    }

    OpenProductDiscountContainer(p:any){

      if(p != null){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.showProductDiscountContainer = true;
      }
    }

    showDocumentDiscountContainer:boolean;
  
    OpenDocumentDiscountContainer(){
      this.showDocumentDiscountContainer = true;
    }

    ApplyDiscount(){

      this.Products.forEach(p => {
        if(p.ProductInvoiceInfo.UIID == this.CurrentProduct.ProductInvoiceInfo.UIID){
          p.ProductInvoiceInfo = this.CurrentProduct.ProductInvoiceInfo;
          this.ModifyReceptionProduct();
        }
      });
      
    }

    DestroySearchedProducts(){
      this.ProductsSearchResultsCOUNT = 0;
      this.ProductsSearchResults = [];

      if(this.NewProduct != undefined){
        if(this.NewProduct.ProductInvoiceInfo != null){
          this.NewProduct.ProductInvoiceInfo.Name = "";
          this.NewProduct.ProductInvoiceInfo.Code = "";
          this.NewProduct.ProductInvoiceInfo.ProductID = null;
        }

        this.NewProduct.ID = null;
        this.NewProduct.SubordonatesInfo = null;
      }
      
      if(this.CurrentProduct != undefined){
        if(this.CurrentProduct.ProductInvoiceInfo != null){
          this.CurrentProduct.ProductInvoiceInfo.Name = "";
          this.CurrentProduct.ProductInvoiceInfo.Code = "";
          this.CurrentProduct.ProductInvoiceInfo.ProductID = null;
        }

          this.CurrentProduct.ID = null;
          this.CurrentProduct.SubordonatesInfo = null;
      }
      
      this.IsValidNewProduct = false;
      this.ProductsSearchResultsCOUNTPop = 0;
      this.ProductsSearchResultsPop = [];
    }

    ApplyInvoiceDiscount(){

      this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;

      if (this.DocumentDate.value._d != undefined) {
        this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
      }
    
      if (this.PaymentDueDate.value._d != undefined) {
        this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
      }

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Invoice:JSON.parse(JSON.stringify(this.CurrentInvoice))
      };
  
      request.Invoice.Products = JSON.parse(JSON.stringify(this.Products));
  
      this.parent.loading = true;
  
      this.service.ApplyInvoiceDiscount(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CurrentInvoice = response["Invoice"];
          this.Products = response["Invoice"].Products;

          this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
          this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
        }
     
        this.showDocumentDiscountContainer = false;
        this.parent.loading = false;
      });
    }

    EliminateDocumentDiscount(){
      this.CurrentInvoice.Total.Discount = {
        Type:null,
        Value:null
      };
  
      this.ApplyInvoiceDiscount();
    }

    EliminateProductDiscount(){
      this.CurrentProduct.ProductInvoiceInfo.Price.Discount = {
        Type:null,
        Value:null
      };
  
      this.ModifyReceptionProduct();
    }

    AdjustProductsDecimalPrecisionPrice(){

      setTimeout(()=>{                         
        if(this.Products != undefined && this.Products != null && this.Products.length > 0){
          this.Products.forEach(p => {
            this.CurrentProduct = JSON.parse(JSON.stringify(p));
            this.CurrentProduct.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;

            var request = {
              User:this.parent.User,
              Language:this.parent.getLanguage(),
              Price:this.CurrentProduct.ProductInvoiceInfo.Price,
              Precision:this.InvoicePrecision.ID,
              HasVAT:this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT,
              Quantity:this.CurrentProduct.ProductInvoiceInfo.Quantity,
              DocQuantity:this.CurrentProduct.ProductInvoiceInfo.DocQuantity,
              IsStorno:this.IsStorno,
              Discount:null
            };
        
            if(this.CurrentProduct.ProductInvoiceInfo.Price.Discount != undefined){
              request.Discount = this.CurrentProduct.ProductInvoiceInfo.Price.Discount;
            }
        
            this.service.GetPriceInformation(request).subscribe(response => {
           
              if(response["Status"] != 1){
                this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
              }
              else if(response["Status"] == 1){
                 
                  this.CurrentProduct.ProductInvoiceInfo.Quantity = response["Quantity"];
                  this.CurrentProduct.ProductInvoiceInfo.DocQuantity = response["DocQuantity"];
                  this.CurrentProduct.ProductInvoiceInfo.Price = response["Price"];
                  p.ProductInvoiceInfo.Price = this.CurrentProduct.ProductInvoiceInfo.Price;
                  p.ProductInvoiceInfo.DecimalPrecision = this.InvoicePrecision;
                  this.GetInvoiceTotalValues();
              }
            });
          });
        }
      }, 0);
  }

  SalesDocumentsPairsCOUNT:number;

  AddInvoice(IgnoreSubordonates = false, DirectSubordonateDocumentsInjection = false){

    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if (this.DocumentDate.value._d != undefined) {
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice,
      IgnoreSubordonates:IgnoreSubordonates,
      DirectSubordonateDocumentsInjection:DirectSubordonateDocumentsInjection
    };

    this.ShowSubordronateDocumentsWarning = false;
    this.parent.loading = true;

    this.service.AddInvoiceFromAccountingAPI(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        if(response["ID"] != null){
          this.CurrentInvoice.ID = response["ID"];
          this.NewCopy = false;
          this.IsStorno = false;
          this.GetInvoice(this.CurrentInvoice.ID, true, true);
          this.showInvoiceVisualizer = true;
        }
        else if(response["ShowSubordronateDocumentsWarning"] == true){
          this.ShowSubordronateDocumentsWarning = true;
          this.SubordronateDocumentsMessage = response["SubordronateDocumentsMessage"];
          this.SalesDocumentsPairsCOUNT = response["SalesDocumentsPairs"].length;
        }
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  ExtractTranzactionsFromSubordonateInfo(){

    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if (this.DocumentDate.value._d != undefined) {
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }
  
    if (this.PaymentDueDate.value._d != undefined) {
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice
    };

    this.parent.loading = true;

    this.service.ExtractTranzactionsFromSubordonateInfo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
      
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  GetEFacturaXML(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
      UseInvoiceLanguage:false,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaXML(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaState(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaState(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.EFacturaDetails = response["EFacturaDetails"];
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  GetEFacturaFiles(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
      InvoiceDetailsID:this.CurrentInvoice.Details.ID,
      FileType:1,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.GetEFacturaFiles(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.GetEFacturaState(i); 
      }
      else if(response["Status"] == 1){
        if(request.FileType == 1){
          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);
        }
        else if(request.FileType == 2){
          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
        else if(request.FileType == 0){

          var PDF = response["PDF"];
          this.download(PDF.Name, PDF.PDFStream);

          var XML = response["XML"];
          this.download(XML.Name, XML.PDFStream);
        }
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  ShowEFacturaQuestion:boolean;

  UploadEFactura(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:this.CurrentInvoice.ID,
      InvoiceDetailsID:this.CurrentInvoice.Details.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.UploadEFactura(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentInvoice.Details.EFacturaDetails = response["EFacturaDetails"];
      }
  
      this.DocumentBodyLoading = false;
      this.parent.RedirectToURL('dashboard/documents/invoices');
    });
  }

  UpdateInvoiceDetails(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Details:this.CurrentInvoice.Details,
      InvoiceID:this.CurrentInvoice.ID
    };

    this.parent.loading = true;

    this.service.UpdateInvoiceDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetInvoice(this.CurrentInvoice.ID, true, true);
        this.showInvoiceVisualizer = true;
      }
    
      this.parent.loading = false;
    });
  }

  UpdateInvoice(){
    this.CurrentInvoice.Client = this.partner;
    this.CurrentInvoice.Currency = this.currency;
    
    if(this.DocumentDate.value._d != undefined){
      this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }

    if(this.PaymentDueDate.value._d != undefined){
      this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;
    this.CurrentInvoice.Products = this.Products;
    this.CurrentInvoice.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Invoice:this.CurrentInvoice
    };

    this.parent.loading = true;

    this.service.UpdateInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetInvoice(this.CurrentInvoice.ID, true, true);
        this.showInvoiceVisualizer = true;
      }

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
      this.parent.loading = false;
    });
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

  PrintInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

  ExportInvoice(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InvoiceID:i.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportInvoice(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  ValidDocument:boolean;

  TestDocumentValidity(){

    this.ValidDocument = true;

    if(this.Products == null || this.Products.length == 0){
      this.ValidDocument = false;
    }

    if(this.DocumentDate.valid == false || this.PaymentDueDate.valid == false){
      this.ValidDocument = false;
    }

    if(this.partner == null){
      this.ValidDocument = false;
    }
  }

  ngAfterContentInit() {
    this.loading = false;
  }

  ShowProformaInvoiceConvertorQuestion = false;

ConvertProformaToInvoiceQuestion(i:any){
  this.CurrentInvoice = i;
  this.ShowProformaInvoiceConvertorQuestion = true;
}

ConvertProformaToInvoice(id:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),

    InvoiceID:id
  };
  
  this.parent.loading = true;

  this.service.ConvertProformaToInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){

      this.ShowProformaInvoiceConvertorQuestion = false;
      this.GetInvoice(this.CurrentInvoice.ID, true);
      this.showInvoiceVisualizer = true;
    }
 
    this.parent.loading = false;
  });
}

GetAdvancePaymentTotal(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Total:this.CurrentInvoice.Total,
    AdvancePaymentPercentage:this.CurrentInvoice.AdvancePaymentPercentage,
    DecimalPrecision:this.InvoicePrecision
  };
  
  this.parent.loading = true;

  this.service.GetAdvancePaymentTotal(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
    
    }
 
    this.parent.loading = false;
  });
}

ImplementAdvancePaymentValues(){

  this.CurrentInvoice.Currency.DecimalPrecision = this.InvoicePrecision;

  if(this.DocumentDate.value._d != undefined){
    this.CurrentInvoice.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
  }

  if(this.PaymentDueDate.value._d != undefined){
    this.CurrentInvoice.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Invoice:JSON.parse(JSON.stringify(this.CurrentInvoice))
  };

  request.Invoice.Products = JSON.parse(JSON.stringify(this.Products));
  this.parent.loading = true;

  this.service.ImplementAdvancePaymentValues(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice = response["Invoice"];
      this.Products = response["Invoice"].Products;

      this.DocumentDate = new FormControl(moment(this.CurrentInvoice.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentInvoice.PaymentDueDate));
    }
 
    this.parent.loading = false;
  });
}

AutoPrintDocument(i:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    InvoiceID:i.ID,
  };

  this.DocumentBodyLoading = true;

  this.service.ExportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.parent.AutoPrintDocument(Document);
    }

    this.DocumentBodyLoading = false;
  });
}

ShowSubordonateProductsAdjustment:boolean;

OpenSubordonateProductsAdjustment(){
  this.ShowSubordonateProductsAdjustment = true;
}

ProductSubordonateAutoAdjust:boolean;
ProductSubordonateFillBacklogDifference:boolean = true;

AutoAdjustProductSubordonateQuantities(AutoAdjust:boolean, Apply:boolean = false){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Product:this.NewProduct,
    AutoAdjust:AutoAdjust,
    FillBacklogDifference:this.ProductSubordonateFillBacklogDifference
  };

  this.parent.loading = true;

  this.service.AutoAdjustProductSubordonateQuantities(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.NewProduct.SubordonatesInfo = response["ProductSubordonatesInfo"];
    }

    this.parent.loading = false;

    if(Apply){
      this.ShowSubordonateProductsAdjustment = false;
    }

  });
}

ProofAllocatesSubordonatesQuantites(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Products:this.Products,
  };

  if(this.CurrentInvoice.DocType.ID == 0 && this.CurrentInvoice.ID == null){
    this.parent.loading = true;

    this.service.ProofAllocatesSubordonatesQuantites(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Products = response["Products"];
      }
  
      this.parent.loading = false;
    });
  }
}

VerifyPriceModel(p:string){
  var result = this.parent.NormalizePrice(p);

  if(this.CurrentProduct != null){
    if(!this.CurrentProduct.ProductInvoiceInfo.PriceContainsVAT){
      this.CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice = result;
    }
    else{
      this.CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = result;
    }
  }

  if(this.NewProduct != null){
    if(!this.NewProductPriceContainsVAT){
      this.NewProduct.ProductInvoiceInfo.Price.UIUnitPrice = result;
    }
    else{
      this.NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice = result;
    }
  }
}

GetShippingDetails(DetailsID:number, PartnerID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ParentDetailsID:DetailsID,
    ShippingMasterData:this.ShippingMasterData,
    PartnerID:PartnerID
  };

  this.parent.loading = true;

  this.service.GetInvoiceShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      this.ShowShippingDetailsContainer = true;
    }
    else if(response["Status"] == 0){
      this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
      this.ShowShippingDetailsContainer = true;
    }

    this.parent.loading = false;
  });
}

AddNewBox(ShippingDetailsID:number){
  var box = {
    ID:0,
    ParentShippingDetailsID:ShippingDetailsID,
    Length:10,
    Width:10,
    Height:10,
    Weight:1,
    TrackingLabel:null,
    UIID:this.parent.newGuid(),
  };

  this.CurrentInvoice.Details.ShippingDetails.Boxes.push(box);
}

ProofShippingDetails(ShippingDetails:number, SaveToDB:boolean = false){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.service.ProofShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowShippingDetailsContainer = false;

      if(SaveToDB == true){

        if(this.CurrentInvoice.Details.ShippingDetails.ID > 0){
          this.UpdateShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
        }
        else{
          this.AddShippingDetails(this.CurrentInvoice.Details.ShippingDetails);
        }
      }
    }
  });
}

ShowDeleteBoxQuestion:boolean;
CurrentBox:any;

DeleteBox(box:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    BoxID:box.ID
  };

  this.parent.loading = true;

  this.service.DeleteInvoiceBox(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails.Boxes = this.CurrentInvoice.Details.ShippingDetails.Boxes.filter(item => item.UIID != box.UIID);
    }

    this.parent.loading = false;
  });
}

AddShippingDetails(ShippingDetails:any){
  
  ShippingDetails.Partner = this.CurrentInvoice.Client;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.parent.loading = true;

  this.service.AddShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
    }

    this.parent.loading = false;
  });
}

UpdateShippingDetails(ShippingDetails:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetails:ShippingDetails,
  };

  this.parent.loading = true;

  this.service.UpdateShippingDetails(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentInvoice.Details.ShippingDetails = response["ShippingDetails"];
    }

    this.parent.loading = false;
  });
} 

TrackInvoice(i:any){

  if(i.Details?.ShippingDetails?.TrackingLabel?.length > 0){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/track/shipment'], { queryParams: { Courier: i.Details.ShippingDetails.ShippingCompany.Name, Tracking: i.Details.ShippingDetails.TrackingLabel } }));
    window.open(nextUrl, '_blank');
  }
}

}

  
